export const transmitText =
    'Recuerda que para dar clic en esta opción debes tener completa la liquidación de la nómina de tus empleados y que la información se encuentre actualizada.';
